import React from 'react'
import { LuDownload } from 'react-icons/lu';
import styles from '../../styles/mainContent/Home.module.css';
import { getResumeUrl } from '../../utils/resumeUtils';

const ResumeIcon: React.FC = () => {
  const icon = LuDownload({});
  return icon as React.JSX.Element;
};

const ResumeDownload = () => {
    return (
        <div style={{ textAlign: 'center' }} >
          <a
            href={getResumeUrl()}
            target="_blank"
            rel="noreferrer"
            className={styles.resumeButton}
          >
            <ResumeIcon /> View Resume
          </a>
        </div>
    )
}

export default ResumeDownload;